import i18n from '@/i18n';
import { TimeStep } from '@/types';
import dayjs from 'dayjs';

const t = i18n.t.bind(i18n);

export const getPresetStep = (initStartTime?: dayjs.ConfigType) => {
  const steps: {
    key: string;
    label: string;
    timeSpan: number;
    value: TimeStep;
  }[] = [
    {
      key: '30s',
      label: t('utils:interval.30.seconds'),
      timeSpan: 30,
      value: '30s',
    },
    {
      key: '1m',
      label: t('utils:interval.minute', { count: 1 }),
      timeSpan: 60,
      value: '1m',
    },
    {
      key: '2m',
      label: t('utils:interval.minute-plural', { count: 2 }),
      timeSpan: 120,
      value: '2m',
    },
    {
      key: '5m',
      label: t('utils:interval.minute-plural', { count: 5 }),
      timeSpan: 300,
      value: '5m',
    },
    {
      key: '10m',
      label: t('utils:interval.minute-plural', { count: 10 }),
      timeSpan: 600,
      value: '10m',
    },
    {
      key: '15m',
      label: t('utils:interval.minute-plural', { count: 15 }),
      timeSpan: 900,
      value: '15m',
    },
    {
      key: '25m',
      label: t('utils:interval.minute-plural', { count: 25 }),
      timeSpan: 1500,
      value: '25m',
    },
    {
      key: '30m',
      label: t('utils:interval.minute-plural', { count: 30 }),
      timeSpan: 1800,
      value: '30m',
    },
    {
      key: '1h',
      label: t('utils:interval.hour', { count: 1 }),
      timeSpan: 3600,
      value: '1h',
    },
    {
      key: '2h',
      label: t('utils:interval.hour-plural', { count: 2 }),
      timeSpan: 7200,
      value: '2h',
    },
    {
      key: '5h',
      label: t('utils:interval.hour-plural', { count: 5 }),
      timeSpan: 18000,
      value: '5h',
    },
    {
      key: '8h',
      label: t('utils:interval.hour-plural', { count: 8 }),
      timeSpan: 28800,
      value: '8h',
    },
    {
      key: '12h',
      label: t('utils:interval.hour-plural', { count: 12 }),
      timeSpan: 43200,
      value: '12h',
    },
    {
      key: '1d',
      label: t('utils:interval.1.day'),
      timeSpan: 86400,
      value: '1d',
    },
  ];

  if (initStartTime) {
    // 当前时间减去初始时间
    const timeVal = dayjs().unix() - dayjs(initStartTime).unix();
    // 过滤掉大于当前时间的时间范围
    const filteredSteps = steps.filter((item) => {
      return timeVal >= item.timeSpan;
    });

    return filteredSteps;
  }

  return steps;
};
